// extracted by mini-css-extract-plugin
module.exports =  {"collect-wrapper":"h8QrodV","collectWrapper":"h8QrodV","collect-btn":"WqQBOmb","collectBtn":"WqQBOmb","collected":"Tmzb3tm"};